import { render } from "./TheVideoCallOverlay.vue?vue&type=template&id=634554b2&scoped=true&ts=true"
import script from "./TheVideoCallOverlay.vue?vue&type=script&lang=ts"
export * from "./TheVideoCallOverlay.vue?vue&type=script&lang=ts"

import "./TheVideoCallOverlay.vue?vue&type=style&index=0&id=634554b2&lang=scss"
import "./TheVideoCallOverlay.vue?vue&type=style&index=1&id=634554b2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634554b2"]])

export default __exports__